"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subscriptions = void 0;
var _auth = require("@ori/auth");
var _presentationHttp = require("@ori/presentation-http");
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _react = require("react");
var _constants = require("../../constants");
var _internal = require("../../hooks/internal");
var _PrimaryButton = require("../PrimaryButton");
var _SubscriptionSection = require("../SubscriptionSection");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const Subscriptions = () => {
  const {
    customerTypeId
  } = (0, _presentationHttp.useUserSegmentationData)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    currentShade: {
      canBeSold,
      canBeSubscribed,
      price: {
        current,
        basicCashback,
        combinedCashback
      },
      productCode,
      subscription: {
        deliveryFrequencyOptions,
        recommendedFrequency,
        available
      }
    },
    currentProduct: {
      name
    }
  } = (0, _internal.useProduct)();
  const {
    originalItemCode,
    originalQuantity,
    personalSubscriptionsEnabled
  } = (0, _internal.useSharedConfiguration)();
  const {
    isSubscriptionReplacement
  } = (0, _internal.useReplaceSubscriptionData)();
  const {
    lineNumber,
    placement
  } = (0, _internal.useAnalyticsData)();
  // istanbul ignore next @preserve -- No need to test fallback
  const formattedPrice = current ?? '';
  const analyticsData = (0, _react.useMemo)(() => ({
    formattedPrice,
    localName: name,
    originalItemCode,
    placement,
    replacementType: originalItemCode ? _constants.MANUAL_REPLACEMENT : undefined
  }), [formattedPrice, name, originalItemCode, placement]);
  if (!isSubscriptionReplacement && available && personalSubscriptionsEnabled) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationProductDetail.SubscriptionModule, {
      analyticsData: analyticsData,
      customerTypeId: customerTypeId,
      deliveryFrequencyOptions: deliveryFrequencyOptions,
      itemCode: productCode,
      purchaseOptionCashback: basicCashback,
      recommendedFrequency: recommendedFrequency,
      subscribeOptionCashback: combinedCashback,
      disabled: !canBeSold,
      addToBagContainerId: `${_PrimaryButton.SUBSCRIPTIONS_ADD_TO_BAG}-${productCode}`,
      lineNumber: lineNumber,
      originalQuantity: originalQuantity,
      subscriptionPlacement: (0, _utils.parseSubscriptionPlacement)(placement)
    });
  }
  if (!isSubscriptionReplacement && canBeSubscribed && isAnonymousUser && !personalSubscriptionsEnabled) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionSection.SubscriptionSection, {});
  }
  return null;
};
exports.Subscriptions = Subscriptions;